const arrayBatch = (arr, batchSize) => {
  const res = []
  for (let i = 0; i < arr.length; i += batchSize) {
    const batch = arr.slice(i, i + batchSize)
    res.push(batch)
  }
  return res
}

export { arrayBatch }
